export const SITE = {
  nav: 'site-nav',
  navBook: 'nav-start-conversation',
  navMenu: 'nav-menu',
  navLink: (slug) => `nav-link-${slug}`,

  hero: 'hero-section',
  heroCta: 'hero-cta-start-conversation',
  heroSecondary: 'hero-cta-what-we-do',

  credibility: 'section-credibility',
  what: 'section-what-we-do',
  why: 'section-why-nobs',
  sectors: 'section-sectors',
  approach: 'section-approach',
  work: 'section-selected-work',
  team: 'section-team',
  reach: 'section-reach',
  contact: 'section-contact',
  footer: 'site-footer',

  book: {
    trigger: 'open-conversation-dialog',
    dialog: 'conversation-dialog',
    name: 'conversation-name',
    email: 'conversation-email',
    company: 'conversation-company',
    phone: 'conversation-phone',
    region: 'conversation-region',
    interest: 'conversation-interest',
    message: 'conversation-message',
    submit: 'conversation-submit',
    success: 'conversation-success',
    close: 'conversation-close',
  },

  contactEmail: 'contact-email-link',
  contactPhone: 'contact-phone-link',
  contactAddress: 'contact-address',
};
